{
  "solIndex": 0,
  "scale": 100000,
  "defaultCamera": {
    "position": {
      "x": 16,
      "y": 10,
      "z": 16
    },
    "target": {
      "x": 0,
      "y": 0,
      "z": 0
    },
    "Perspective": {
      "fov": 75,
      "near": 0.1,
      "far": 1000
    }
  }
}
